/* Ott-common */
import { assetTypes } from '@dtvgo/rtk-query-api';

/* Utils */
import {
  PDP_ASSET_TYPES,
  PUBLIC_PDP,
} from './constants';

export function savePdpUrlToStorage() {
  localStorage.setItem(
    PUBLIC_PDP,
    window.location.href,
  );
}

export function getPdpTypeFromAsset(type) {
  let pdpType;

  switch (type) {
    case assetTypes.movie:
      pdpType = PDP_ASSET_TYPES.movies;
      break;
    case assetTypes.serie:
    case assetTypes.episode:
      pdpType = PDP_ASSET_TYPES.series;
      break;
    case assetTypes.channel:
    case assetTypes.liveMovie:
    case assetTypes.liveSerie:
    case assetTypes.liveEpisode:
    case assetTypes.liveShow:
    case assetTypes.liveSport:
      pdpType = PDP_ASSET_TYPES.live;
      break;
    case assetTypes.show:
    case assetTypes.sport:
      pdpType = PDP_ASSET_TYPES.vod;
      break;
    default:
      pdpType = type;
      break;
  }

  return pdpType;
}

export function getBadgeLabelTitle(type) {
  let label;

  switch (type) {
    case assetTypes.movie:
    case assetTypes.liveMovie:
      label = 'common.movie';
      break;
    case assetTypes.serie:
    case assetTypes.episode:
    case assetTypes.liveEpisode:
    case assetTypes.liveSerie:
      label = 'common.series';
      break;
    case assetTypes.channel:
    case assetTypes.liveShow:
    case assetTypes.liveSport:
    case assetTypes.show:
    case assetTypes.sport:
      label = 'common.live';
      break;
    default:
      break;
  }

  return label;
}
